import { useMemo } from 'react';
import { ReactComponent as TaskArrowIcon } from 'assets/icons/taskArrow.svg';
import { compareStrings } from 'utils/formatText';

import type { ITaskInfoActivityItem } from './interfaces/ITaskInfoActivityItem';

import styles from './sass/TaskInfoActivityItem.module.scss';

function TaskInfoActivityItem({
  title,
  beforeValue,
  afterValue,
  disableComparison = false,
}: ITaskInfoActivityItem) {
  const beforeDiff = useMemo(
    () => (disableComparison
      ? [{ text: beforeValue, isDifferent: true }]
      : compareStrings(beforeValue, afterValue)),
    [beforeValue, afterValue, disableComparison],
  );

  const afterDiff = useMemo(
    () => (disableComparison
      ? [{ text: afterValue, isDifferent: true }]
      : compareStrings(afterValue, beforeValue)),
    [beforeValue, afterValue, disableComparison],
  );

  return (
    <div className={styles.itemContainer}>
      <span className={styles.itemContainerTitle}>
        {title}
      </span>
      <div className={styles.itemContainerValue}>
        { beforeValue ? (
          <span className={styles.textValue}>
            {beforeDiff.map((chunk) => (
              <span
                key={`before-${chunk.text}-${chunk.isDifferent}`}
                className={chunk.isDifferent ? styles.isDifferent : ''}
              >
                {chunk.text}
              </span>
            ))}
          </span>
        ) : null}
        {beforeValue && afterValue ? <TaskArrowIcon /> : null}
        {afterValue ? (
          <span className={styles.textValue}>
            {afterDiff.map((chunk) => (
              <span
                key={`after-${chunk.text}-${chunk.isDifferent}`}
                className={chunk.isDifferent ? styles.isDifferent : ''}
              >
                {chunk.text}
              </span>
            ))}
          </span>
        ) : null}
      </div>
    </div>
  );
}

export default TaskInfoActivityItem;
